// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-749b4c7e]{display:none}.badge-number[data-v-749b4c7e]{background-color:var(--c-secondary-pink-500);border-radius:var(--border-radius-rounded);bottom:35%;color:var(--c-white);font-size:10px;font-weight:var(--font-weight--medium);height:15px;left:65%;line-height:1.5;outline:2px solid var(--c-white);position:absolute;width:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
